module.exports = __webpack_public_path__ + "static/1126508104.fc789341.jpg";